import {
  usePlaybackIsPlaying,
  usePlaybackIsSeeking,
  usePlaybackPause,
} from '@app/core/playback/hooks/usePlayback';
import { useDownloadMediaFromSelection } from '@app/modules/logger/screens/stream/features/download-media';
import { useCanPlaySelection } from '@app/modules/logger/screens/stream/hooks/selection/useCanPlaySelection';
import { useCopyQuickShareURLFromSelection } from '@app/modules/logger/screens/stream/hooks/selection/useSelectionActions';
import { useStreamSettingsStore } from '@app/modules/logger/screens/stream/stores/stream-screen-settings.store';
import { useStreamSelection } from '@app/modules/logger/screens/stream/stores/useStreamSelection';
import { useIntl } from 'react-intl';
import { usePlaySelection } from '../../../../hooks/playback/useStreamPlayback';
import { useOpenFragmentDrawer } from '../useOpenFragmentDrawer';
import { SelectionMenuDefaultP } from './SelectionMenuDefaultP';

export function SelectionMenuDefault() {
  const isSeeking = usePlaybackIsSeeking();
  const isPlaying = usePlaybackIsPlaying();
  const pause = usePlaybackPause();
  const playSelection = usePlaySelection();
  const { $t } = useIntl();
  // Only hide when create-fragment is already open; other drawers (e.g. live-topics) can be replaced.
  const isCreateFragmentDrawerOpen = useStreamSettingsStore(
    (s) => s.drawerType === 'create-fragment',
  );
  const openFragmentDrawer = useOpenFragmentDrawer();
  const { clearSelection } = useStreamSelection();
  const canPlay = useCanPlaySelection();
  const { downloadMedia, downloadAudioMedia, isPreparingVideoDownload, isPreparingAudioDownload } =
    useDownloadMediaFromSelection();
  const copyQuickShareURLFromSelection = useCopyQuickShareURLFromSelection();

  return (
    <SelectionMenuDefaultP
      loadingAudio={isSeeking}
      play={canPlay ? () => playSelection() : null}
      pause={isPlaying ? () => pause() : null}
      createFragment={isCreateFragmentDrawerOpen ? null : openFragmentDrawer}
      downloadMedia={downloadMedia}
      downloadAudioMedia={downloadAudioMedia}
      isPreparingVideoDownload={isPreparingVideoDownload}
      isPreparingAudioDownload={isPreparingAudioDownload}
      copyQuickShareUrl={() => copyQuickShareURLFromSelection($t)}
      clear={clearSelection}
    />
  );
}
